require("dotenv").config();
const URL = process.env.REACT_APP_API_URL || "http://localhost/api/";
const URL_TOKEN =
  process.env.REACT_APP_TOKEN_URL || "http://localhost/oauth/token";
const LOCALHOST_URL =
  process.env.REACT_APP_API_LOCALHOST_URL || "http://localhost/";
export default {
  user: URL + "user",
  token: URL_TOKEN,
  changeResetedPassword: URL + "password/reset",
  changePassword: URL + "password/change",
  resetPassword: URL + "password/create",
  resendPassword: URL + "password/resend",
  findToken: URL + "password/find",
  contracts: URL + "contracts",
  pushNotification: URL + "fcm/notifications/push",
  defaultFranchise: URL + "default-franchise",
  contract(id) {
    return {
      get: id => URL + "contracts/" + id,
      matrices: id => URL + "contracts/" + id + "/authorizationMatrix",
      policies: id => URL + "contracts/" + id + "/policies"
    };
  },
  contractTypes: URL + "contracts/types",
  contractOrigins: URL + "contracts/origins",
  hansa_contacts: URL + "contacts",
  contract_authorization_matrix: URL + "contracts/authorizationMatrix",
  authorization_matrix: URL + "authorizationMatrix",
  authorization_matrix() {
    return {
      audit: id => URL + "contracts/authorizationMatrix/" + id + "/audit",
      get: id => URL + "contracts/authorizationMatrix/" + id,
      post: () => URL + "authorizationMatrix",
      patch: id => URL + "authorizationMatrix/" + id,
      delete: id => URL + "authorizationMatrix/" + id,
      preview: id => URL + "authorizationMatrix/" + id + "/preview",
      export: id => URL + "authorizationMatrix/" + id + "/export",
      export_plate: plate =>
        URL + "authorizationMatrix/vehicle/" + plate + "/export"
    };
  },
  authorization_matrix_vehicles: URL + "authorizationMatrix/vehicles",
  contract_policy: URL + "contracts/policy",
  policy: URL + "policy",
  policy() {
    return {
      audit: id => URL + "contracts/policy/" + id + "/audit",
      get: id => URL + "contracts/policy/" + id,
      post: id => URL + "contracts/" + id + "/policy",
      patch: id => URL + "contracts/policy/" + id,
      delete: id => URL + "policy/" + id,
      preview: id => URL + "policy/" + id + "/preview",
      export: id => URL + "policy/" + id + "/export",
      export_plate: plate => URL + "policy/vehicle/" + plate + "/export"
    };
  },
  sla() {
    return {
      get: id => URL + "contracts/serviceAgreement/" + id,
      post: id => URL + "contracts/" + id + "/serviceAgreement",
      patch: id => URL + "contracts/serviceAgreement/" + id,
      delete: id => URL + "serviceAgreement/" + id
    };
  },
  service() {
    return {
      get: id => URL + "contracts/service/" + id,
      getServiceCharge: id => URL + "contracts/service-charge/" + id,
      addVehiclesToServiceCharge: id =>
        URL + "contracts/service-charge/" + id + "/vehicles",
      post: id => URL + "contracts/" + id + "/service",
      patch: id => URL + "contracts/service/" + id,
      delete_charge: id => URL + "contracts/service/charge/" + id
    };
  },
  bookings() {
    return {
      get: id => URL + "booking/" + id,
      post: () => URL + "bookings",
      paginate: () => URL + "bookings",
      patch: id => URL + "booking/" + id,
      transition: id => URL + "booking/" + id + "/state",
      shifts: () => URL + "bookings/shifts",
      storeQuote: () => URL + "bookings/quote",
      storeBooking: id => URL + "bookings/quote/" + id + "/booking",
      exportBooking: id => URL + "bookings/" + id + "/export",
      quotes: () => URL + "bookings/quotes",
      quote: id => URL + "bookings/quote/" + id,
      exportQuote: id => URL + "bookings/quote/" + id + "/export",
      createWorkOrder: id => URL + "bookings/" + id + "/work_order",
      createRelation: id => URL + "bookings/" + id + "/relation",
      states: () => URL + "bookings-states",
      priceChangesImport: () => URL + "bookings/price-changes/import",
      downloadTelepaseTolls: id => URL + "bookings/" + id + "/telepase-tolls/export"
    };
  },
  geodefender_fines() {
    return {
      index: clientId => {
        let url = URL + "geodefender_fines";
        if (clientId) {
          url += "?client_id=" + clientId;
        }
        return url;
      },
      import: () => URL + "geodefender_fines/import",
      createWorkOrders: () => URL + "geodefender_fines/create-work-orders"
    };
  },
  contacts() {
    return {
      autocomplete: name => URL + "contacts?name=" + name,
      get: id => URL + "contacts/" + id,
      deleteAddress: id => URL + "address/" + id,
      addresses: id => URL + "contact/" + id + "/addresses",
      updateCuitVerificationDate: () =>
        URL + "taxdata/updateCuitVerificationDate",
      getAfipCaptcha: cuit => URL + "taxdata/afip_generate_captcha/" + cuit,
      validateAfipCaptcha: (cuit, code, bar, contact_id) =>
        URL +
        "taxdata/afip_validate?bar=" +
        bar +
        "&code=" +
        code +
        "&cuit=" +
        cuit +
        "&contact_id=" +
        contact_id,
      updateCuitVerificationDateNoAfip: () =>
        URL + "taxdata/noAfip/updateCuitVerificationDate",
      dummyDriver: () => URL + "autocorp_driver",
      validateCuit: (document_number, parent_contact_id = 0) =>
        URL +
        "contacts?document_number=" +
        document_number +
        "&parent_contact_id=" +
        parent_contact_id,
      validateEmail: (email, parent_contact_id = 0) =>
        URL +
        "contacts?email=" +
        email +
        "&parent_contact_id=" +
        parent_contact_id
    };
  },
  subcontacts() {
    return {
      get: id => URL + "contacts/subcontacts/" + id,
      getMobileSubcontact: id => URL + "mobile/contacts/subcontacts/" + id,
      index: (
        id,
        q,
        subcontact_type_id,
        page,
        column,
        order,
        q_rows,
        deleted_at = 0
      ) =>
        URL +
        "subcontacts/" +
        id +
        "?q=" +
        q +
        "&subcontact_type_id=" +
        subcontact_type_id +
        "&page=" +
        page +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows +
        "&with_deleted=" +
        deleted_at,
      all: id => URL + "subcontacts/" + id + "/all",
      audit: id => URL + "contacts/subcontact/" + id + "/audit",
      post: id => URL + "contacts/subcontacts",
      patch: id => URL + "contacts/subcontacts/" + id,
      restore: id => URL + "contacts/subcontacts/restore/" + id,
      delete: id => URL + "contacts/subcontacts/" + id,
      feature: () => URL + "contacts/subcontacts/features",
      comment: id => URL + "contacts/subcontacts/" + id + "/comment",
      export: () => URL + "subcontacts/export",
      import: () => URL + "subcontacts/import"
    };
  },
  providers() {
    return {
      get: id => URL + "contacts/provider/" + id,
      all: () => URL + "providers/all",
      audit: id => URL + "contacts/provider/" + id + "/audit",
      post: id => URL + "contacts/provider",
      patch: id => URL + "contacts/provider/" + id,
      delete: id => URL + "contacts/provider/" + id,
      restore: id => URL + "contacts/provider/restore/" + id,
      feature: () => URL + "contacts/provider/features",
      index: (
        id,
        q,
        provider_type,
        column,
        order,
        q_rows,
        hansa_code = "",
        deleted_at = 0,
        is_main_provider = "",
        lat = "",
        lng = ""
      ) =>
        URL +
        "providers?q=" +
        q +
        "&provider_type=" +
        provider_type +
        "&page=" +
        id +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows +
        "&hansa_code=" +
        hansa_code +
        "&with_deleted=" +
        deleted_at +
        "&is_main_provider=" +
        is_main_provider +
        "&lat=" +
        lat +
        "&long=" +
        lng,
      comment: id => URL + "contacts/provider/" + id + "/comment",
      latlng: (
        long,
        lat,
        business_name,
        is_official,
        provider_type_id,
        best_score,
        most_near,
        plate,
        has_crane,
        has_valet,
        has_rebate,
        code
      ) =>
        URL +
        "providers/latlong?long=" +
        long +
        "&lat=" +
        lat +
        "&business_name=" +
        business_name +
        "&best_score=" +
        best_score +
        "&most_near=" +
        most_near +
        "&is_official=" +
        is_official +
        "&provider_type_id=" +
        provider_type_id +
        "&plate=" +
        plate +
        "&has_valet=" +
        has_valet +
        "&has_crane=" +
        has_crane +
        "&has_rebate=" +
        has_rebate +
        "&code=" +
        code,
      export: () => URL + "providers/export",
      pendingToInvoice: id => URL + "ots/vouchers/provider/" + id + "/pending",
      rebateProviders: () => URL + "vouchers/rebates"
    };
  },
  client_groups() {
    return {
      index: () => URL + "client_groups",
      get: id => URL + "client_group/" + id,
      post: id => URL + "client_group",
      patch: id => URL + "client_group/" + id,
      delete: id => URL + "client_group/" + id
    };
  },
  clients() {
    return {
      get: id => URL + "contacts/client/" + id,
      clientExposures: () => URL + "clients/account-balance",
      refreshExposures: () => URL + "clients/refresh-account-balance",
      getVehicles: id => URL + "contacts/client/" + id + "/vehicles",
      autocomplete: client => URL + "clients/autocomplete/" + client,
      audit: id => URL + "contacts/client/" + id + "/audit",
      post: id => URL + "contacts/client",
      restore: id => URL + "contacts/client/restore/" + id,
      patch: id => URL + "contacts/client/" + id,
      delete: id => URL + "contacts/client/" + id,
      deleteStructure: id => URL + "client_structure/" + id,
      index: (
        id,
        q,
        client_type,
        column,
        order,
        q_rows = 10,
        hansa_code = "",
        with_deleted = 0
      ) =>
        URL +
        "clients?q=" +
        q +
        "&client_type=" +
        client_type +
        "&page=" +
        id +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows +
        "&hansa_code=" +
        hansa_code +
        "&with_deleted=" +
        with_deleted,
      all: () => URL + "clients/all",
      comment: id => URL + "contacts/client/" + id + "/comment",
      autocomplete: param => URL + "clients/autocomplete/" + param,
      export: () => URL + "clients/export"
    };
  },
  client_routes() {
    return {
      get: id => URL + "route_costs/" + id,
      post: () => URL + "route_cost",
      patch: id => URL + "route_cost/" + id,
      delete: id => URL + "route_cost/" + id
    };
  },
  client_expenses() {
    return {
      get: id => URL + "client_expenses/" + id,
      post: () => URL + "client_expense",
      patch: id => URL + "client_expense/" + id,
      delete: id => URL + "client_expense/" + id
    };
  },
  client_subscriptions() {
    return {
      catalog: () => URL + "clients/subscriptions",
      get: id => URL + "clients/" + id + "/subscriptions",
      post: () => URL + "clients/subscription",
      patch: id => URL + "clients/subscription/" + id
    };
  },
  categories() {
    return {
      get: id => URL + "categories/" + id + "/tasks",
      getAll: () => URL + "categories"
    };
  },
  brands() {
    return {
      index: () => URL + "brands",
      autocomplete: brand => URL + "brands/autocomplete/" + brand,
      get: id => URL + "brand/" + id,
      post: id => URL + "brand",
      patch: id => URL + "brand/" + id,
      delete: id => URL + "brand/" + id,
      aldnet_makers: () => URL + "aldnet_makers"
    };
  },
  models() {
    return {
      all: () => URL + "variations/",
      index: brand_id => URL + "variations/" + brand_id,
      export: brand_id => URL + "versions/" + brand_id + "/export",
      get: id => URL + "variation/" + id,
      post: id => URL + "variation",
      patch: id => URL + "variation/" + id,
      delete: id => URL + "variation/" + id
    };
  },
  versions() {
    return {
      index: (brand_id = 0) => URL + "versions/" + brand_id,
      get: id => URL + "version/" + id,
      autocomplete: version => URL + "version/autocomplete/" + version
    };
  },
  vehicles() {
    return {
      get: id => URL + "vehicle/" + id,
      index: (all = 0) => URL + "vehicles?all=" + all,
      indexAc: (available = 0, plate = "", version_name = "") =>
        URL +
        "vehiclesAc" +
        "?available=" +
        available +
        "&plate=" +
        plate +
        "&version_name=" +
        version_name,
      post: () => URL + "vehicle",
      patch: id => URL + "vehicle/" + id,
      delete: id => URL + "vehicle/" + id,
      colors: () => URL + "vehicle/colors",
      fuel_providers: () => URL + "vehicle/fuel_providers",
      tier_variations: () => URL + "vehicle/tier_variations",
      tier_brands: () => URL + "vehicle/tier_brands",
      tier_types: () => URL + "vehicle/tier_types",
      expirations: (
        days,
        vtv_due_date,
        cardoc_due_date,
        fire_extinguisher_due_date,
        warranty_up_to_date,
        service_last_date,
        mailing_day
      ) =>
        URL +
        "vehicle/expirations?days=" +
        days +
        "&vtv_due_date=" +
        vtv_due_date +
        "&cardoc_due_date=" +
        cardoc_due_date +
        "&fire_extinguisher_due_date=" +
        fire_extinguisher_due_date +
        "&warranty_up_to_date=" +
        warranty_up_to_date +
        "&service_last_date=" +
        service_last_date +
        "&mailing_day=" +
        mailing_day,
      expirations_export: (
        days,
        vtv_due_date,
        cardoc_due_date,
        fire_extinguisher_due_date,
        warranty_up_to_date,
        service_last_date,
        mailing_day
      ) =>
        URL +
        "vehicles/export/expirations?days=" +
        days +
        "&vtv_due_date=" +
        vtv_due_date +
        "&cardoc_due_date=" +
        cardoc_due_date +
        "&fire_extinguisher_due_date=" +
        fire_extinguisher_due_date +
        "&warranty_up_to_date=" +
        warranty_up_to_date +
        "&service_last_date=" +
        service_last_date +
        "&mailing_day=" +
        mailing_day,
      send_expiration_mails: (
        days,
        vtv_due_date,
        cardoc_due_date,
        fire_extinguisher_due_date,
        warranty_up_to_date,
        service_last_date
      ) =>
        URL +
        "vehicles/send/expirations?days=" +
        days +
        "&vtv_due_date=" +
        vtv_due_date +
        "&cardoc_due_date=" +
        cardoc_due_date +
        "&fire_extinguisher_due_date=" +
        fire_extinguisher_due_date +
        "&warranty_up_to_date=" +
        warranty_up_to_date +
        "&service_last_date=" +
        service_last_date,
      states: (vehicle_id = "") =>
        URL + "vehicle/states?vehicle_id=" + vehicle_id,
      gps_providers: () => URL + "vehicle/gps_providers",
      equipment_types: () => URL + "vehicle/equipment_types",
      subcontact_relation_types: () =>
        URL + "vehicle/subcontact_relation_types",
      autocomplete: plate => URL + "vehicle/autocomplete/" + plate,
      history: plate => URL + "vehicle/history/" + plate,
      hansaHistory: plate => URL + "vehicle/hansa/history/" + plate,
      pricingHistory: id => URL + "vehicle/" + id + "/pricing_history",
      storePricingHistory: id => URL + "vehicle/" + id + "/pricing_history",
      export: () => URL + "vehicles/export",
      import: id => URL + "vehicles/import/" + id,
      importZip: () => URL + "vehicles/importZippedFolderAttachments",
      attachments: () => URL + "vehicles/mobile/attachments",
      grouped: (is_fleet_owner = null) =>
        URL +
        "vehicles/grouped" +
        (is_fleet_owner ? "?is_fleet_owner=" + is_fleet_owner : ""),
      tracking: () => URL + "vehicles/tracking"
    };
  },
  insurances() {
    return {
      index: () => URL + "insurances",
      post: () => URL + "insurance",
      get: id => URL + "insurance/" + id,
      patch: id => URL + "insurance/" + id,
      delete: id => URL + "insurance/" + id,
      brokers: () => URL + "brokers",
      producers: () => URL + "producers",
      insurance_types: () => URL + "insurance_types"
    };
  },
  media() {
    return {
      delete: id => URL + "media/" + id
    };
  },
  hansa_media() {
    return {
      index: () => URL + "hansa/media",
      download: (id, model) =>
        URL + "hansa/download?hansa_code=" + id + "&model=" + model
    };
  },
  work_order() {
    return {
      index: (closed, mine = 1, id = "") =>
        URL + "ots?closed=" + closed + "&mine=" + mine + "&id=" + id,
      index_grouped: () => URL + "work_orders/grouped?closed=0&mine=1",
      shifts: () => URL + "shifts",
      get: (id, closed = 0) => URL + "ot/" + id + "?closed=" + closed,
      post: () => URL + "ot",
      tasks_autocomplete: (task, is_sellable = 0) =>
        URL + "tasks/autocomplete/" + task + "?is_sellable=" + is_sellable,
      tasks_autocomplete: (task = "", is_sellable = 0) =>
        URL +
        "tasks/autocomplete" +
        (task ? "/" + task : "") +
        "?is_sellable=" +
        is_sellable,
      new: () => URL + "init/ot",
      transition: id => URL + "ot/" + id,
      history: id => URL + "ot/history/" + id,
      attach_media: id => URL + "ot/attach_media/" + id,
      attachments: id => URL + "ot/attachments/" + id,
      vouchers: id => URL + "ot/" + id + "/vouchers",
      novouchers: () => URL + "ots/vouchers/pending",
      invoices: id => URL + "ot/" + id + "/invoices",
      delete: id => URL + "ot/" + id,
      users: () => URL + "users/ot",
      peding_cuit_verification: () => URL + "ots/pending_cuit_verification",
      comment: id => URL + "ot/" + id + "/comment",
      comments: id => URL + "ot/" + id + "/comments",
      export: () => URL + "work_orders/export",
      type_tasks_autocomplete: (task, type = "") =>
        URL +
        "work_order_type/tasks/autocomplete?task=" +
        task +
        "&type=" +
        type,
      import: () => URL + "work_orders/import",
      getState: id => URL + "ot/" + id + "/state",
      assign: () => URL + "ot/assign",
      preview_email_shift: () => URL + "shift/preview",
      resend_shift_email: () => URL + "shift/resend",
      restore: id => URL + "ot/restore/" + id,
      forceOCSAP: id => URL + "ot/" + id + "/purchase_order",
      forceReceptionSAP: id => URL + "ot/" + id + "/delivery_notes",
      assignSAPProject: id => URL + "ot/" + id + "/sap_project"
    };
  },
  work_order_tasks() {
    return {
      delete: id => URL + "work_order_task/" + id
    };
  },
  work_order_alerts() {
    return {
      index: id => URL + "work_order/" + id + "/work_order_alerts",
      post: () => URL + "work_orders/work_order_alert",
      patch: id => URL + "work_orders/work_order_alert/" + id,
      user_alerts: () => URL + "work_order_alerts/user_alerts",
      export: (id = "") =>
        URL + "work_order_alerts/user_alerts/export?work_order_id=" + id,
      reclaim_types: () => URL + "work_order_user_alert/reclaim_types",
      reasonsTypes: () => URL + "work_order_user_alert/subjects_types",
      commentsTypes: () => URL + "work_order_user_alert/comments_types",
      dropdowns: id => URL + "work_order_user_alert/dropdowns/" + id
    };
  },
  budgets() {
    return {
      approve: id => URL + "budget/approve/" + id,
      post: () => URL + "budget",
      patch: id => URL + "budget/" + id,
      export: (id, detailed) =>
        URL + "budget/" + id + "/" + detailed + "/export",
      delete: id => URL + "budget/" + id
    };
  },
  vouchers() {
    return {
      index: (voucher_state_id = "") =>
        URL + "vouchers?voucher_state_id=" + voucher_state_id,
      get: id => URL + "voucher/" + id,
      getByNumber: () => URL + "vouchers/number",
      post: id => URL + "voucher",
      patch: id => URL + "voucher/" + id,
      approve: id => URL + "voucher/approve/" + id,
      forceattachment: id => URL + "voucher/forceattachment/" + id,
      delete: id => URL + "vouchers/" + id,
      reject: () => URL + "voucher/reject",
      tasks_available: id => URL + "ot/" + id + "/voucher/tasks_available",
      downloadSapVoucher: id => URL + "voucher/download/" + id
    };
  },
  dropdowns() {
    return {
      ot: () => URL + "dropdowns/ot",
      vehicle: () => URL + "dropdowns/vehicle"
    };
  },
  relations() {
    return {
      get: id => URL + "work_order_relation/" + id,
      post: id => URL + "work_order_relation",
      remove: id => URL + "work_order_relation/" + id,
      duplicate: id => URL + "ot/duplicate/" + id
    };
  },
  sinisters() {
    return {
      patch: id => URL + "sinister/" + id,
      post: id => URL + "sinister",
      work_order_sinister: id => URL + "work_order/sinister/" + id,
      reclaims: id => URL + "sinister/" + id + "/reclaims",
      types: id => URL + "sinister_types",
      downloadTemplate: id => URL + "sinister/template/" + id
    };
  },
  sinister_lawyer_diligences() {
    return {
      patch: id => URL + "sinister_lawyer_diligence/" + id,
      post: id => URL + "sinister_lawyer_diligence",
      work_order_sinister: id => URL + "sinister_lawyer_diligence/" + id
    };
  },
  vehicle_movements() {
    return {
      post: () => URL + "vehicle_movement",
      patch: id => URL + "vehicle_movement/" + id,
      get: id => URL + "work_order/vehicle_movement/" + id,
      transport_means: () => URL + "vehicle_movement/transport_means",
      export: () => URL + "vehicle_movements/export"
    };
  },
  work_order_checklists() {
    return {
      post: () => URL + "work_order_checklist",
      patch: id => URL + "work_order_checklist/" + id,
      get: id => URL + "work_order/work_order_checklist/" + id,
      export: id => URL + "work_order_checklist/" + id + "/export"
    };
  },
  work_order_parking() {
    return {
      post: () => URL + "work_order_parking",
      patch: id => URL + "work_order_parking/" + id,
      get: id => URL + "work_order/work_order_parking/" + id
    };
  },
  work_order_fine() {
    return {
      post: () => URL + "work_order_fine",
      patch: id => URL + "work_order_fine/" + id,
      get: id => URL + "work_order/work_order_fine/" + id,
      sendEmail: id => URL + "work_order_fine/" + id + "/send_email",
      getFineTasks: () => URL + "work_order_fine/tasks"
    };
  },
  work_order_approval() {
    return {
      approvers: id => URL + "work_order_approval/" + id + "/approvers",
      post: () => URL + "work_order_approval",
      patch: id => URL + "work_order_approval/" + id,
      get: id => URL + "work_order/work_order_approval/" + id,
      show: id => URL + "work_order_approvals/" + id,
      approve: id => URL + "work_order_approvals/approve/" + id,
      reject: id => URL + "work_order_approvals/reject/" + id,
      cancel: id => URL + "work_order_approvals/cancel/" + id,
      reclaim: id => URL + "work_order_approval/reclaim/" + id
    };
  },
  work_order_tier_changes() {
    return {
      post: () => URL + "work_order_tier_changes",
      patch: () => URL + "work_order_tier_changes/",
      get: id => URL + "work_order/work_order_tier_changes/" + id,
      restart: id => URL + "work_order_tier_changes/restart/" + id
    };
  },
  valet() {
    return {
      post: () => URL + "valet",
      patch: id => URL + "valet/" + id,
      get: id => URL + "work_order/valet/" + id,
      restore: id => URL + "valet/restore/" + id
    };
  },
  valet_budget() {
    return {
      post: () => URL + "valet_budget",
      patch: id => URL + "valet_budget/" + id,
      get: id => URL + "valet_budget/" + id
    };
  },
  mobile_messages() {
    return {
      ot: id => URL + "mobile_messages/ot/" + id,
      plate: plate => URL + "mobile_messages/plate/" + plate
    };
  },
  maintenance_plans() {
    return {
      get: id => URL + "maintenance_plan/" + id,
      index: () => URL + "maintenance_plans",
      post: () => URL + "maintenance_plan",
      patch: id => URL + "maintenance_plan/" + id,
      delete: id => URL + "maintenance_plan/" + id,
      delete_task: id => URL + "maintenance_plan_task/" + id,
      assignVariations: () => URL + "maintenance_plan_variations",
      unAssignVariations: id => URL + "maintenance_plan_variations/" + id,
      expirations: id => URL + "maintenance_plan/" + id + "/expirations/",
      expirations_export: id =>
        URL + "maintenance_plan/" + id + "/expirations/export",
      export: id => URL + "maintenance_plan/" + id + "/export",
      assignVariationsImport: () => URL + "maintenance_plan_variations/import"
    };
  },
  users() {
    return {
      index: () => URL + "admin/users",
      get: (id, email = "") => URL + "admin/user/" + id + "?email=" + email,
      post: () => URL + "admin/users/register",
      patch: id => URL + "admin/user/" + id,
      delete: id => URL + "admin/user/" + id,
      getConfig: (key = "") => URL + "user_config/" + key,
      storeConfig: () => URL + "user_config"
    };
  },
  mobileUsers() {
    return {
      index: () => URL + "admin/mobile/users",
      export: () => URL + "admin/mobile/users/export",
      post: () => URL + "admin/users/mobile",
      deleteMobileData: id => URL + "device/info/" + id
    };
  },
  providerUsers() {
    return {
      index: () => URL + "admin/provider/users",
      post: () => URL + "admin/users/provider"
    };
  },
  dashboardUsers() {
    return {
      index: () => URL + "admin/dashboard/users",
      export: () => URL + "admin/dashboard/users/export",
      post: () => URL + "admin/users/dashboard",
      impersonate: () => URL + "admin/user/dashboard-impersonate"
    };
  },
  roles() {
    return {
      index: () => URL + "admin/roles",
      get: id => URL + "admin/roles/" + id,
      post: () => URL + "admin/roles/",
      patch: () => URL + "admin/permissions/givePermissionToRole"
    };
  },
  permissions() {
    return {
      index: () => URL + "admin/permissions"
    };
  },
  provinces() {
    return {
      get: () => URL + "provinces",
      cities: id => URL + "province/" + id + "/cities"
    };
  },
  hansa_pending_sync() {
    return {
      index: () => URL + "hansaSyncLog"
    };
  },
  crons() {
    return {
      index: () => URL + "indexCrons",
      run: () => URL + "runCron"
    };
  },
  freshdesk() {
    return {
      post: () => URL + "freshdesk/ticket"
    };
  },
  reports() {
    return {
      index: () => URL + "reports",
      get: id => URL + "reports/" + id,
      post: () => URL + "report",
      download: id => URL + "export-progress/" + id
    };
  },
  infoauto() {
    return {
      search: string => URL + "infoauto/search?q=" + string
    };
  },
  clientInvoicingConfigs() {
    return {
      index: (page, q, column, order, q_rows) =>
        URL +
        "client_invoicing_configs?page=" +
        page +
        "&q=" +
        q +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows,
      show: id => URL + "client_invoicing_configs/" + id,
      post: () => URL + "client_invoicing_config",
      patch: id => URL + "client_invoicing_config/" + id
    };
  },
  tasksAdmin() {
    return {
      index: (isProductive = 1) =>
        URL + "tasks-admin/tasks" + "?is_productive=" + (isProductive ? 1 : 0),
      groups: (isProductive = 1) =>
        URL + "tasks-admin/groups" + "?is_productive=" + (isProductive ? 1 : 0),
      get: id => URL + "tasks-admin/tasks/" + id,
      post: () => URL + "tasks-admin/tasks",
      patch: id => URL + "tasks-admin/tasks/" + id,
      delete: id => URL + "tasks-admin/tasks/" + id
    };
  },
  clientChargeInvoices() {
    return {
      index: (page, q, column, order, q_rows) =>
        URL +
        "client_charge_invoices?page=" +
        page +
        "&q=" +
        q +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows,
      download: () => URL + "client_charge_invoices/export"
    };
  },
  invoicing_schedules: URL + "invoicing-schedules",
  invoicing_schedules_commands: URL + "invoicing-schedules-commands",
  invoices() {
    return {
      index: (page, q, column, order, q_rows) =>
        URL +
        "invoices?page=" +
        page +
        "&q=" +
        q +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows,

      get: id => URL + "invoices/" + id,
      post: () => URL + "invoices",
      patch: id => URL + "invoice/" + id,
      retry: id => URL + "invoices/retry/" + id,
      retryAll: () => URL + "invoices/retry-batch",
      export_excel: id => URL + "invoices/" + id + "/excel-export",
      rebill: id => URL + "invoices/rebill/" + id
    };
  },
  credit_notes() {
    return {
      index: (page, q, column, order, q_rows) =>
        URL +
        "credit_notes?page=" +
        page +
        "&q=" +
        q +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows,

      get: id => URL + "credit_notes/" + id,
      post: () => URL + "credit_notes"
    };
  },
  debit_notes() {
    return {
      index: (page, q, column, order, q_rows) =>
        URL +
        "debit_notes?page=" +
        page +
        "&q=" +
        q +
        "&order=" +
        column +
        "&direction=" +
        order +
        "&q_rows=" +
        q_rows,

      get: id => URL + "debit_notes/" + id,
      post: () => URL + "debit_notes"
    };
  },
  sales_users: URL + "sales-users",
  min_fce_value: URL + "fce-min-amount",
  invoice_levels: URL + "invoice-levels",
  invoice_item_types: URL + "invoice_item_types",
  tasksAdmin() {
    return {
      index: (isProductive = 1) =>
        URL + "tasks-admin/tasks" + "?is_productive=" + (isProductive ? 1 : 0),
      groups: (isProductive = 1) =>
        URL + "tasks-admin/groups" + "?is_productive=" + (isProductive ? 1 : 0),
      get: id => URL + "tasks-admin/tasks/" + id,
      post: () => URL + "tasks-admin/tasks",
      patch: id => URL + "tasks-admin/tasks/" + id,
      delete: id => URL + "tasks-admin/tasks/" + id
    };
  },
  sapProjects() {
    return {
      index: () => URL + "sap/projects",
      get: id => URL + "sap/project/" + id,
      post: () => URL + "sap/project"
    };
  },
  //    provinces: URL + 'provinces',
  cities: URL + "cities",
  voucher_types: URL + "voucher_types",
  charges: URL + "charge_types",
  address_types: URL + "address_types",
  equipment_types: URL + "equipment_types",
  structure_types: URL + "structure_types",
  document_types: URL + "document_types",
  provider_types: URL + "provider_types",
  grouped_provider_types: URL + "grouped_provider_types",
  equipment_types: URL + "equipment_types",
  vehicle_types: URL + "vehicle_types",
  combustion_types: URL + "combustion_types",
  transmition_types: URL + "transmition_types ",
  iva_types: URL + "iva_types",
  iva_conditions: URL + "iva_conditions",
  gamas: URL + "gamas",
  countries: URL + "countries",
  client_trade_types: URL + "client_trade_types ",
  client_tiers: URL + "client_tiers",
  operation_types: URL + "operation_types ",
  invoice_types: URL + "invoice_types ",
  point_of_sales: URL + "point-of-sales ",
  client_state_types: URL + "client_state_types ",
  client_origin_types: URL + "client_origin_types ",
  client_iibb_types: URL + "client_iibb_types ",
  performed_types: URL + "performed_types",
  subcontact_types: URL + "subcontact_types",
  clients_subcontact_types: URL + "clients/subcontact_types",
  providers_subcontact_types: URL + "providers/subcontact_types",
  client_types: URL + "client_types",
  workOrderStates: URL + "workOrderStates",
  policy_vehicles: URL + "policy/vehicles",
  tasks: URL + "tasks",
  authorization_matrices_tasks: URL + "authorization_matrices_tasks",
  media_download: URL + "media/download",
  media_path: URL + "media/path",
  hansa_media_download: URL + "hansa/download",
  vehicle_import_template:
    LOCALHOST_URL + "public/storage/templates/vehicle_import_template.xlsx",
  vehicle_update_template:
    LOCALHOST_URL + "public/storage/templates/vehicle_update_template.xlsx",
  vehicle_duedates_update_template:
    LOCALHOST_URL +
    "public/storage/templates/vehicle_expirations_update_template.xlsx",
  subcontacts_import_template:
    LOCALHOST_URL + "public/storage/templates/subcontact_import_template.xlsx",
  maintenance_versions_import_template:
    LOCALHOST_URL +
    "public/storage/templates/maintenance_versions_import_template.xlsx",
  booking_price_changes_import_template:
    LOCALHOST_URL +
    "public/storage/templates/booking_price_changes_import_template.xlsx",
  payment_deals: URL + "payment_deals",
  payment_methods: URL + "payment_methods",
  usernames: URL + "usernames",
  suscription_types: URL + "suscription_types",
  sap_tasks_groups: URL + "sap_tasks_groups",
  banks: URL + "banks"
};
